import {useAppDispatch, useAppSelector} from '../hooks'
import {
  selectNotificationBanner,
  selectNotificationAdminBanner,
  updateBanner,
  updateAdminBanner
} from '../slices/notificationBannerSlice'

// Approach 1. COMPLEX HOOK - For backward compatibility and convenience
// Use when: Migrating from Context, need all banner functionality together
export const useNotificationBanner = () => {
  const dispatch = useAppDispatch()
  const banner = useAppSelector(selectNotificationBanner)
  const adminBanner = useAppSelector(selectNotificationAdminBanner)

  return {
    banner,
    adminBanner,
    updateBanner: (value) => dispatch(updateBanner(value)),
    updateAdminBanner: (value) => dispatch(updateAdminBanner(value))
  }
}

// Approach 2. SIMPLE SELECTOR HOOKS - For targeted access
// Use when: Only need specific values, performance-critical components
export const useBanner = () => useAppSelector(selectNotificationBanner)
export const useAdminBanner = () => useAppSelector(selectNotificationAdminBanner)
